import { Controller } from '@hotwired/stimulus'

import MicroModal from 'micromodal'

export default class extends Controller {
  static targets = [
    'scrollable'
  ]

  static values = {
    'gb': { type: Boolean, default: false }
  }

  connect() {
    this.setGlobalVariables()

    this.setDeviceWidth()

    this.initMicromodal()

    this.removeFacebookTrash()
  }

  setGlobalVariables() {
    window.currentUserId = Number(document.body.dataset.currentUserId) || 0
    window.currentUserUsername = document.body.dataset.currentUserUsername || ''
  }

  setDeviceWidth() {
    var iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

    if (iOS) {
      document.head.querySelector('meta[name="viewport"]').content = "width=device-width, initial-scale=1, maximum-scale=1"
    } else {
      document.head.querySelector('meta[name="viewport"]').content = "width=device-width, initial-scale=1"
    }
  }

  initMicromodal() {
    MicroModal.init({
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      disableScroll: true
    })
  }

  // Feb 2025: Facebook oauth forwards to url with this in the end: #_=_
  // We need to remove it, because it breaks the page (ie tiptap editor)
  removeFacebookTrash() {
    if (window.location.hash === '#_=_') {
      window.history.replaceState?.(null, null, window.location.href.split('#')[0])
        || (window.location.hash = '')
    }
  }
}
